// src/lib/meterStatus.ts
// Shared between the UI layer (app/(dashboard)/meter/utils/meterStatus.ts,
// which re-exports this for display) and the query layer
// (lib/db/queries/meters.ts, which filters/sorts by it) so the two never
// disagree on what "online" means.
export type MeterOnlineStatus = "online" | "offline" | "unknown";

const ONLINE_THRESHOLD_MINUTES = 120;

export function computeMeterStatus(
  latest_online_at: string | null,
  now: number = Date.now(),
): MeterOnlineStatus {
  if (!latest_online_at) return "unknown";
  const lastOnline = new Date(latest_online_at);
  if (isNaN(lastOnline.getTime())) return "unknown";
  const diffMinutes = Math.floor((now - lastOnline.getTime()) / 60_000);
  return diffMinutes <= ONLINE_THRESHOLD_MINUTES ? "online" : "offline";
}
